import type { QueryClient } from "@tanstack/react-query";
import type { WorktreeDetailResponse } from "@rivets/core";
import { client } from "./api";
import { qk } from "./query-keys";
import { preserveWorktreeParticipants } from "@/features/chat/chat-cache";

/** All readers of the shared key must merge against the cache at completion. */
export async function fetchWorktreeDetail(queryClient: QueryClient, worktreeId: string, signal?: AbortSignal): Promise<WorktreeDetailResponse> {
  const incoming = await client.withSignal(signal).worktreeDetail(worktreeId);
  const known = queryClient.getQueryData<string[]>(qk.worktreeParticipants(worktreeId)) ?? [];
  return preserveWorktreeParticipants(queryClient.getQueryData(qk.worktree(worktreeId)), {
    ...incoming, participantIds: [...new Set([...(incoming.participantIds ?? []), ...known])],
  });
}
